export {
  setFlagInLocalStorage,
  getFlagFromLocalStorageOrWindow,
} from './localStorageFlags'
